module.exports = __webpack_public_path__ + "assets/img/4-2.6d02c5d3.svg";